var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReserve = function SvgReserve(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7845 36.8386H8.45117C3.45117 36.8386 3.45117 34.5886 3.45117 31.8386V30.1719C3.45117 29.2552 4.20117 28.5052 5.11784 28.5052H35.1178C36.0345 28.5052 36.7845 29.2552 36.7845 30.1719V31.8386C36.7845 34.5886 36.7845 36.8386 31.7845 36.8386Z",
    stroke: "#E8EBEA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7015 21.8386V28.5052H5.61816V21.8386C5.61816 15.4386 10.1348 10.0886 16.1515 8.80522C17.0515 8.60522 17.9848 8.50522 18.9515 8.50522H21.3682C22.3348 8.50522 23.2848 8.60522 24.1848 8.80522C30.2015 10.1052 34.7015 15.4386 34.7015 21.8386Z",
    stroke: "#E8EBEA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3348 7.67189C24.3348 8.07189 24.2848 8.43855 24.1848 8.80522C23.2848 8.60522 22.3348 8.50522 21.3681 8.50522H18.9515C17.9848 8.50522 17.0515 8.60522 16.1515 8.80522C16.0515 8.43855 16.0015 8.07189 16.0015 7.67189C16.0015 5.37189 17.8681 3.50522 20.1681 3.50522C22.4681 3.50522 24.3348 5.37189 24.3348 7.67189Z",
    stroke: "#E8EBEA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.168 18.5052H15.168",
    stroke: "#E8EBEA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgReserve;